// communicationServices.js

import apiClient from './apiClient';

export const markCommunicationAsRead = async (communicationId, userId) => {
    const data = {
        communication_id: communicationId,
        user_id: userId,
    };

    const response = await apiClient.post(
        '/communications.php?action=markAsRead',
        data,
        {
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );
    return response.data;
};

export const fetchCommunications = async (userId, isDirector, hideRead, page = 1, pageSize = 10) => {
    if (!userId) {
        console.error('Errore: userId non definito');
        return { status: 'error', data: [], total: 0, page, pageSize };
    }

    try {
        const response = await apiClient.get(
            `/communications.php?action=fetch&user_id=${userId}&is_director=${isDirector}&hide_read=${hideRead}&page=${page}&pageSize=${pageSize}`
        );

        const data = response.data;

        if (!data || data.status !== 'success' || !Array.isArray(data.data)) {
            console.error('Errore: risposta non valida o vuota:', data);
            return { status: 'error', data: [], total: 0, page, pageSize };
        }

        return {
            status: 'success',
            data: data.data,
            total: hasTotal(data) ? data.total : data.data.length,
            page: data.page ?? page,
            pageSize: data.pageSize ?? pageSize
        };
    } catch (error) {
        console.error('Errore nel recupero delle comunicazioni:', error);
        return { status: 'error', data: [], total: 0, page, pageSize };
    }
};

const hasTotal = (obj) => {
    return obj && Object.prototype.hasOwnProperty.call(obj, 'total');
};

export const getCommunicationViews = async (communicationIds) => {
    if (!Array.isArray(communicationIds) || communicationIds.length === 0) {
        console.error('Nessun ID comunicazione fornito per recuperare le visualizzazioni.');
        return [];
    }

    try {
        const views = await Promise.all(
            communicationIds.map(async (id) => {
                const response = await apiClient.get(`/views.php?action=getCommunicationViews&communication_id=${id}`);
                return { communicationId: id, views: response.data };
            })
        );
        return views;
    } catch (error) {
        console.error('Errore nel recupero delle visualizzazioni delle comunicazioni:', error);
        throw error;
    }
};

export const addCommunication = async (formData) => {
    try {
        const response = await apiClient.post(
            '/communications.php?action=create',
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const removeCommunication = async (communicationId) => {
    const response = await apiClient.delete(`/communications.php?action=delete&communication_id=${communicationId}`);
    return response.data;
};

export const updateCommunication = async (formData) => {
    try {
        const response = await apiClient.post(
            '/communications.php?action=update',
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error('Errore durante l\'aggiornamento della comunicazione:', error);
        throw error;
    }
};
